// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_to-0";